// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"ProgressDashboard_dashboardContainer__8AjOo","chartWrapper":"ProgressDashboard_chartWrapper__biCQv","loading":"ProgressDashboard_loading__LQ4jS"};